import { render, staticRenderFns } from "./RegionDashboard.vue?vue&type=template&id=86c36414"
import script from "./RegionDashboard.vue?vue&type=script&lang=js"
export * from "./RegionDashboard.vue?vue&type=script&lang=js"
import style0 from "./RegionDashboard.vue?vue&type=style&index=0&id=86c36414&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports